import { Link, useLocation } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { useSettings, buildWhatsAppLink, onWhatsAppClick } from "@/contexts/SettingsContext";
import WhatsAppIcon from "@/components/WhatsAppIcon";

export default function Footer() {
  const { settings } = useSettings();
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <footer className="border-t border-[color:var(--bda-border)] mt-8 py-10" data-testid="site-footer">
      <div className="mx-auto max-w-[935px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-5 text-[11px] text-[color:var(--bda-text-dim)]">
          <div className="flex items-center gap-6 tracking-wider">
            <span>© {new Date().getFullYear()} BuildDirect Africa</span>
            <Link to="/contact" className="hover:text-[color:var(--bda-text)] transition-colors">Contact</Link>
            <Link to="/admin/login" className="hover:text-[color:var(--bda-text)] transition-colors" data-testid="footer-admin-link">Admin</Link>
          </div>
          <div className="flex items-center gap-5">
            {settings?.instagram && (
              <a href={settings.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="text-[color:var(--bda-text-dim)] hover:text-[color:var(--bda-text)] transition-colors">
                <Instagram className="w-[15px] h-[15px]" strokeWidth={1.4} />
              </a>
            )}
            {settings?.facebook && (
              <a href={settings.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="text-[color:var(--bda-text-dim)] hover:text-[color:var(--bda-text)] transition-colors">
                <Facebook className="w-[15px] h-[15px]" strokeWidth={1.4} />
              </a>
            )}
            {settings?.whatsapp_number && (
              <a href={buildWhatsAppLink(settings.whatsapp_number)} target="_blank" rel="noopener noreferrer" onClick={onWhatsAppClick} aria-label="WhatsApp" className="opacity-80 hover:opacity-100 transition-opacity">
                <WhatsAppIcon className="w-[15px] h-[15px]" color="#25D366" />
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
